import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setLoading } from "../../../Redux/action";
import toast from "react-hot-toast";
import IsActive from "../AdminisActive";
import {callTestimonial} from "../../callApi/home"
export const Testimonials = () => {
  const storedData = localStorage.getItem("adminData") || " {}";
  const adminData = JSON.parse(storedData);
  const AdminId = adminData.AdminId || null;
  const dispatch = useDispatch();

  const [data, setData] = useState({
    AdminId: AdminId,
    ShowInWebSite: "",
    heading: "",
    reviewCards: [],
  });
  const _data = data;

  // update data state
  const updateData = () => {
    setData((data) => ({
      ...data,
      ..._data,
    }));
  };

  const [option, setOption] = useState(false);


  // check if any field is empty
  const isEmpty = () => {
    let res = false;
    data.reviewCards.forEach((card) => {
      if (card.name.length === 0 && card.desc.length === 0) {
        res = true;
      } else {
        res = false;
      }
    });
    return res;
  };

  const handleChange = () => {
    setOption(!option);
    if (option) {
      data.ShowInWebSite = 0;
    } else {
      data.ShowInWebSite = 1;
    }
  };
  // function to save data
  const handleSave = () =>{
    dispatch(setLoading(true));

    if(isEmpty && data.heading.length !== 0){
      dispatch(setLoading(false))
      const params = data
      callTestimonial(params).then((res)=>{
        dispatch(setLoading(false))
        if(res){
          toast.success("Data saved successfully")
        } else{
          toast.error("Something went wrong")
        }
      })
    } else{
      dispatch(setLoading(false))
      toast.error("Please fill all the values")
    }
  }
 
  // get data from session storage
  useEffect(()=>{
    dispatch(setLoading(true))
    const testimonialData = JSON.parse(sessionStorage.getItem("homeApi")).Testimonial || {}
    dispatch(setLoading(false));
    const {ShowInWebSite, heading, content} = testimonialData

    _data.heading = heading
    _data.ShowInWebSite = ShowInWebSite
    _data.reviewCards = content
    setOption(testimonialData ? testimonialData.ShowInWebSite === 1 : false);
    updateData()
  }, [])

  return (
    <div className="test-div">
      <h2 className="main-heading">Testimonial </h2>
      <div className="input-container">
        <label for="testimonial-title">Heading</label>
        <input
          id="testimonial-title"
          type="text"
          className="validate heading-input"
          maxLength={30}
          placeholder="heading"
          onChange={(e) => {
            const { value } = e.target;
            const _data = data;
            _data.heading = value;
            updateData();
          }}
          value={data.heading}
        />
      </div>
        <button className="add-button" onClick={()=>{
          _data.reviewCards.push({
            name:"",
            desc:""
          })
          updateData()
        }}>
          Add+
        </button>
      <div className="review-cards-div">
        {data?.reviewCards?.map((card, index)=>{
          return(
            <div className="review-card" key={index}>
              <input className="test-input" type="text" name="card-heading" value={card.name} placeholder="name" onChange={(event)=>{
                let text =  event.currentTarget.value
               
                _data.reviewCards[index].name = text
                updateData()
              }}/>
                
              
              <textarea className="test-textarea" type="text" name="card-text" value={card.desc} placeholder="description" onChange={(event)=>{
                
                let text = event.currentTarget.value
                _data.reviewCards[index].desc = text
                updateData()
              }}/>
               
              <button className="remove-card-button width30" 
              onClick={()=>{
                const filteredArray = _data.reviewCards.filter((card)=> _data.reviewCards.indexOf(card) !== index)
                _data.reviewCards = filteredArray
                updateData()
              }}>
                Remove
              </button>
            </div>
          )
        })}
      </div>
      <div className="input-field">
        <label>
          <IsActive
            checked={option}
            onChange={handleChange}
          />
        </label>
      </div>
      
      <button className="btn save" onClick={handleSave}>
        Save
      </button>
    </div>
  );
};
